import { Component } from '@angular/core';
import { localizationKeys } from './../../../utils/localizationKeys';

@Component({
    selector: 'app-component-welcome-page-footer',
    templateUrl: './welcomePageFooter.component.html',
    styleUrls: ['./welcomePageFooter.component.scss'],
})
export class WelcomePageFooterComponent {
    localizationKeys = localizationKeys;
}
